import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pat-payment-panel-adyen-applepay',
  templateUrl: './pat-payment-panel-adyen-applepay.component.html',
  standalone: false,
})
export class PatPaymentPanelAdyenApplepayComponent {
  @Input() clientKey?: string;
  @Input() useTestApi?: boolean;
  @Input() googlePayMerchantName?: string;
  @Input() googlePayMerchantId?: string;
  @Input() googlePayGatewayMerchantId?: string;
  @Input() paymentMethodCbAvailable?: string;
  @Input() paymentMethodPaypalAvailable = false;
  @Input() paymentMethodGooglePayAvailable = false;
  @Input() paymentMethodApplePayAvailable = false;
}
